<template>
  <div v-if="!userDetails?.premiumGames?.includes('geogrid')" class="wrapper">
    <div id="adngin-mobile_mrec-0"></div>
  </div>
</template>

<script>
  import { activateAdUnit } from '../../utils/ads';
  import { inject } from 'vue';

  export default {
    name: 'MobileMrecAd',
    inject: ['isAdScriptLoaded'],
    watch: {
      isAdScriptLoaded: {
        handler(isLoaded) {
          console.log({ isLoaded });
          if (!isLoaded) return;
          if (window.innerWidth > 1024) return;
          console.log('activate mobile_mrec');
          activateAdUnit('mobile_mrec');
        },
        immediate: true,
      },
    },
    setup() {
      return {
        userDetails: inject('userDetails'),
      };
    },
  };
</script>

<style scoped>
  .wrapper {
    min-height: 100px;
    margin: 14px 0.2rem;
    position: relative;
    z-index: 30;
    display: block;
    position: relative;
  }
  @media (min-width: 1024px) {
    .wrapper {
      display: none;
    }
  }
</style>
